import { graphql, useStaticQuery } from "gatsby";

export const useArticlePosts = () => {
    const { articles } = useStaticQuery(graphql`
        query ArticlePostsQuery {
            articles: allContentfulArticle(sort: { publishDate: DESC }) {
                nodes {
                    slug
                    publishDate(formatString: "MMMM DD, YYYY")
                    image {
                        gatsbyImageData(layout: CONSTRAINED)
                        title
                        description
                        file {
                            contentType
                            url
                        }
                    }
                    title
                    topic {
                        id
                        slug
                        name
                    }
                    body {
                        raw
                    }
                }
            }
        }
    `);

    return articles?.nodes;
};
